import React from "react";
import ButtonControl from "../../../../components/controls/ButtonControl";
import FileUploaderControl from "../../../../components/controls/FileUploaderControl";
import { CheckboxInputField } from "../../../../components/controls/InputField/CheckboxInputField";
import { ChipInputField } from "../../../../components/controls/InputField/ChipInputField";
import { InputField } from "../../../../components/controls/InputField";
import { FormatUTCDateTime } from "../../../../utilities/DateFormater";
import { useAppUserManager } from "../../../../hooks/useManagers";

export default function UploadSection({
  itemData,
  forceValidation,
  handleOnChange,
  fileLoading,
  setFileLoading,
  alert,
  handleOnCancel,
  handleOnSave,
  canWrite,
}) {
  const itemCanSave =
    itemData.AiStatus === 0 ||
    itemData.AiStatus === 1 ||
    itemData.AiStatus === 2;

  const authMgr = useAppUserManager();
  const permissions = authMgr?.GetGlobalState()?.permissions ?? [];

  return (
    <div className="control-box-column-content control-box-upload">
      <div className="control-box-inner control-box-inner-column upload-control light-gray">
        <div>
          <InputField
            title="Upload Content"
            forceValidate={forceValidation}
            value={itemData?.FileId}
            onChange={(value) => handleOnChange(value, "FileId")}
            groupId={"CONTENT"}
            fieldName="FileId"
            validationName={"Content_FileId"}
            subTitle={
              "Drag content into or click the box below to upload content."
            }
          >
            <FileUploaderControl
              canUploadAnyFile={true}
              controlId={`content`}
              isPublic={itemData?.IsPublicContent ?? false}
              value={itemData?.FileId}
              fileUrl={itemData?.File?.FileUrl}
              overrideMaxWidth={890}
              widthRes={1920}
              heightRes={280}
              maxFileSize={1024 * 1024 * 99}
              onFileLoading={(val) =>
                setFileLoading({ ...fileLoading, content: val })
              }
            />
          </InputField>
          {itemData?.FileName && (
            <div className="control-box-inner-column">
              <div>
                <h5>{itemData?.FileName}</h5>
                {(itemData?.File?.FileSize / 1000000)?.toFixed(2)} mb
              </div>
              <div className="control-box-inner-row">
                <div>
                  <div className="control-box-inner-row">
                    <h5>Posted:</h5>
                    {FormatUTCDateTime(itemData?.File?.CreatedDate)}
                  </div>
                  By: {itemData?.File?.CreatedBy}
                </div>
                <div>
                  <div className="control-box-inner-row">
                    <h5>Last Updated:</h5>
                    {FormatUTCDateTime(itemData?.File?.UpdatedDate)}
                  </div>
                  By: {itemData?.File?.UpdatedBy}
                </div>
              </div>
            </div>
          )}
        </div>
        <div>
          <InputField
            title="Upload Display Image"
            onChange={(value) => handleOnChange(value, "ThumbnailFileId")}
            value={itemData?.ThumbnailFileId}
            maxLength={100}
            groupId={"CONTENT"}
            fieldName="ThumbnailFileId"
            validationName={"Content_IsActive"}
            subTitle={
              "Drag an image into or click the box  below to upload an image."
            }
          >
            <FileUploaderControl
              controlId={`displayContent`}
              isPublic={itemData?.IsPublicDisplayContent ?? false}
              overrideMaxWidth={890}
              value={itemData?.ThumbnailFileId}
              fileUrl={itemData?.ThumbnailFile?.FileUrl}
              widthRes={1920}
              heightRes={280}
              onFileLoading={(val) =>
                setFileLoading({ ...fileLoading, image: val })
              }
            />
          </InputField>
          <CheckboxInputField
            class="small"
            title="Verify that this image can be available for trending content"
            value={itemData?.IsPublicDisplayContent ?? false}
            onChange={handleOnChange}
            maxLength={100}
            groupId={"CONTENT"}
            field="IsPublicDisplayContent"
            disabled={itemData?.ThumbnailFileId !== null}
          />
        </div>
        {authMgr?.AccessCheck([permissions?.VirtualLibrarianMgmt]) && (
          <div>
            <ChipInputField
              title="Enhanced Search AI-only tags (not visible to end-user)"
              value={itemData?.AiOnlyTags}
              onChange={handleOnChange}
              groupId={"CONTENT"}
              placeholder={"AI-only Tags"}
              maxLength={2000}
              subTitle={"These are additional tags attached to this item."}
              fieldName="AiOnlyTags"
            />

            <div className="small-file-btn">
              <ButtonControl onClick={() => alert("Copy This Set")}>
                Copy This Set
              </ButtonControl>
              <ButtonControl onClick={() => alert("Paste Copied Set")}>
                Paste Copied Set
              </ButtonControl>
            </div>
          </div>
        )}
      </div>
      <div className="control-box-column-content control-box-upload light-blue">
        <div className="control-box-inner control-box-inner-column">
          <CheckboxInputField
            title="Enabled for use by the Front End Modules"
            value={itemData?.IsActive ?? false}
            onChange={handleOnChange}
            maxLength={100}
            groupId={"CONTENT"}
            field="IsActive"
            subTitle={
              <>
                Will be published to the CMS and available for use by the EEPass
                Front End Modules
              </>
            }
          />
        </div>
      </div>
      <div
        className={`control-box-column-content control-box-upload light-gray ${
          !itemData?.IsActive ? "content-disabled" : ""
        }`}
      >
        <div className="control-box-inner control-box-inner-column">
          <h4>Publish to Front End Modules</h4>
          <div className="control-box-inner-row">
            <div>
              <CheckboxInputField
                title="OK for Content Library"
                value={!itemData?.HideFromLibrary ?? true}
                onChange={handleOnChange}
                maxLength={100}
                groupId={"CONTENT"}
                field="OkContentLibrary"
                isDisabled={!itemData?.IsActive}
              />
              <CheckboxInputField
                title="OK for Front Page"
                value={itemData?.IsPublicContent ?? false}
                onChange={handleOnChange}
                maxLength={100}
                groupId={"CONTENT"}
                field="IsPublicContent"
                isDisabled={
                  itemData?.FileId !== null || !itemData?.IsActive || true
                }
              />
              <CheckboxInputField
                title="OK for Certification"
                value={itemData?.UseForCertification ?? false}
                onChange={handleOnChange}
                maxLength={100}
                groupId={"CONTENT"}
                field="UseForCertification"
                isDisabled={!itemData?.IsActive}
              />
            </div>
            {authMgr?.AccessCheck([permissions?.VirtualLibrarianMgmt]) && (
              <div>
                <CheckboxInputField
                  title="OK for ECHO Admin"
                  value={itemData?.IsAiAdmin ?? false}
                  onChange={handleOnChange}
                  maxLength={100}
                  groupId={"CONTENT"}
                  field="IsAiAdmin"
                  isDisabled={!itemData?.IsActive}
                />
                <CheckboxInputField
                  title="OK for ECHO User"
                  value={itemData?.IsAI ?? false}
                  onChange={handleOnChange}
                  maxLength={100}
                  groupId={"CONTENT"}
                  field="IsAI"
                  isDisabled={!itemData?.IsActive}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      {!itemData.IsActive && (
        <div className="control-box-content ul-warning">
          <ul>
            <li>WILL ONLY BE PUBLISHED TO THE CMS</li>
          </ul>
        </div>
      )}
      {itemCanSave && (
        <div className="control-box-content ul-warning">
          <ul>
            <li>
              Content cannot be saved while the file is being processed by Enhanced Search
            </li>
          </ul>
        </div>
      )}
      <div className="screen-footer">
        <div className="btn-wrapper-left screen-footer__btn">
          <ButtonControl type={"cancel"} onClick={handleOnCancel}>
            Cancel
          </ButtonControl>
        </div>
        {canWrite && (
          <div className="btn-wrapper-right screen-footer__btn">
            <ButtonControl
              disabled={fileLoading.content || fileLoading.image || itemCanSave}
              type={"okay"}
              onClick={handleOnSave}
            >
              Save
            </ButtonControl>
          </div>
        )}
      </div>
    </div>
  );
}
